document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('[data-product-card]');
  
  productCards.forEach(card => {
    const tags = card.innerHTML;

    if (tags.includes("top_regalo")) {
      const decor = document.createElement("div");
      decor.innerHTML = `<img src="https://i.imgur.com/6xDh3S2.png" alt="Regalo del día de la madre" style="position: absolute; top: 0; left: 0; width: 80px; z-index: 99;" />`;

      const imageWrapper = card.querySelector('.product--wrapper') || card.querySelector('.grid-product__image-wrapper');

      if (imageWrapper) {
        imageWrapper.style.position = 'relative';
        imageWrapper.appendChild(decor);
      }
    }
  });
});

